// AnimatedCoin.js
import React, { useEffect } from "react";
import "./AnimatedCoin.css";

export default function AnimatedCoin({ isFlipping, onDone }) {
  // Whenever isFlipping goes from false->true, we start an animation. Then
  // after 1 second, pick "Heads" or "Tails" and call onDone(...).

  useEffect(() => {
    if (isFlipping) {
      // after 1 second, finalize outcome
      const timer = setTimeout(() => {
        const outcome = Math.random() < 0.5 ? "Heads" : "Tails";
        onDone && onDone(outcome);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isFlipping, onDone]);

  // The coin will visually spin if isFlipping is true
  return (
    <div className="coin-container">
      <div className={`coin ${isFlipping ? "flip" : ""}`}>
        <div className="coin-face coin-heads">Heads</div>
        <div className="coin-face coin-tails">Tails</div>
      </div>
    </div>
  );
}
